"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var CheckOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M397.07 803.1a47.9 47.9 0 01-37.82-13.91l-248.9-248.9a48 48 0 1167.88-67.88l214.96 214.96 452.55-452.55a48 48 0 0167.88 67.88L427.14 789.2a47.81 47.81 0 01-30.07 13.9z" } }] }, "name": "check", "theme": "outlined" };
exports.default = CheckOutlined;
